import { configureWhitelabel } from "./config.base";

export const whitelabelConfig = configureWhitelabel();